import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, pipe, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  providers: []
})
export class ReportsComponent implements OnInit {
  searchedValue = '';
  searchKey = 'name'
  reportName = [];
  searchText: string;
  public searchInput: any = new Subject<string>();
  public reportModule: any = [];
  public availableReports = [
    {
      name: 'SOS Report',
      icon: 'assets/images/reports/sos.png',
      path: `sos-reports`,
      disabled: false,
    },
    {
      name: 'Over Speed Report',
      icon: 'assets/images/reports/over-speed.png',
      path: 'overspeed-reports',
      disabled: false,
    },

    {
      name: 'Movement Report',
      icon: 'assets/images/reports/movement.png',
      path: `movement-reports`,
      disabled: false,
    },
    {
      name: 'Halt Report',
      icon: 'assets/images/reports/halt.png',
      path: `halt-reports`,
      disabled: false,
    },
    {
      name: 'Productivity Report on Trip',
      icon: 'assets/images/reports/productivity.png',
      path: 'productivity-reports',
      disabled: false,
    },
    {
      name: 'Offline Report',
      icon: 'assets/images/reports/offline.png',
      path: 'offline-reports',
      disabled: false,
    },
    // {
    //   name: 'Vehicle Booking History',
    //   icon: 'assets/images/reports/vehicle-arrivel.png',
    //   path: 'vehicle-booking-history',
    //   disabled:false,
    // },
    {
      name: 'Employee Booking Reports',
      icon: 'assets/images/reports/employee-boarding-ticket.png',
      path: 'employee-booking-reports',
      disabled: false,
    },
    {
      name: 'App Usage Report',
      icon: 'assets/images/reports/app.png',
      path: 'app-reports',
      disabled: false,
    },
    {
      name: 'Safe Drop Report',
      icon: 'assets/images/reports/safely-delivered-1.png',
      path: 'safe-drop-reports',
      disabled: false,
    }, {
      name: 'Attendance',
      icon: 'assets/images/reports/verified-list.png',
      path: 'attendance-reports',
      disabled: false,
    },
    {
      name: 'Trip Report',
      icon: 'assets/images/reports/trip.png',
      path: 'trip-reports',
      disabled: false,
    },
    {
      name: 'MIS Report',
      icon: 'assets/images/reports/trip.png',
      path: 'mis-reports',
      disabled: false
    },
    {
      name: 'Complaint Ratings',
      icon: 'assets/images/reports/complaint-rating.png',
      path: 'complaint-ratings',
      disabled: false,
    },
    {
      name: 'Head Counts',
      icon: 'assets/images/information/organization.png',
      path: 'head-reports',
      disabled: false,
    },
    {
      name: 'Geo Entry Exit',
      icon: 'assets/images/information/location.png',
      path: 'geo-reports',
      disabled: false,
    },
    {
      name: 'Vehicle Audit Report',
      icon: 'assets/images/reports/audit-report.png',
      path: 'vehicle-audit-report',
      disabled: false,
    },
    {
      name: 'Tow Alert Report',
      icon: 'assets/images/reports/tow.png',
      path: `towalert-report`,
      disabled: false,
    }, {
      name: 'Night Drive Report',
      icon: 'assets/images/reports/movement.png',
      path: `night-drive-report`,
      disabled: false,
    }, {
      name: 'Continuous Driving Report',
      icon: 'assets/images/reports/movement.png',
      path: `continuous-driving-report`,
      disabled: false,
    },
    {
      // name: 'Driver App Usage Report',
      name: 'Mobile App Usage Report',
      icon: 'assets/images/reports/app.png',
      path: `mobile-app-usage-reports`,
      disabled: false,
    },
    {
      name: 'Harsh Acceleration Braking',
      icon: 'assets/images/reports/over-speed.png',
      path: 'harsh-acceleration-braking',
      disabled: false,
    },
    // {
    //   name: 'Vehicle Arriving Time',
    //   icon: 'assets/images/reports/vehicle-arrivel.png',
    //   disabled:true,
    // },
    // {
    //   name: 'Employee Boarding History',
    //   icon: 'assets/images/reports/employee-boarding-history.png',
    //   disabled:true,
    // }, {
    //   name: 'Seat Occupancy Report',
    //   icon: 'assets/images/reports/seet.png',
    //   disabled:true,
    // }, {
    //   name: 'Route Violation',
    //   icon: 'assets/images/reports/violation.png',
    //   disabled:true,
    // },
    /*  {
      name: 'Geofence Violation',
      icon: 'assets/images/reports/geofence.png',
      disabled:true,
    },  */
    // {
    //   name: 'GPS Failure',
    //   icon: 'assets/images/reports/gps-failure.png',
    //   disabled:true,
    // },

  ];
  public userInfo: any = {};
  public userRestrictionData: any = {};
  public showNoSearch: boolean = false;
  constructor(
    public router: Router,
    public storage: StorageService,
    public api: ApiService
  ) {
    // this.searchInput.pipe(debounceTime(500), distinctUntilChanged()).subscribe(value => {
    //   this.reportModule.filter((item: any) => {
    //     if (item.name.toLowerCase().includes(value.toLowerCase())) {
    //       this.reportModule.push(item);
    //     }
    //   });
    // });
  }

  ngOnInit(): void {
    this.showNoSearch = false;
    this.userInfo = this.storage.get('userInfo');
    const obj = {
      orgID: this.userInfo.orgID
    };
    this.api.org_settingsList(obj).then((res: any) => {
      let mail = this.userInfo.userEmail;
      let selectedUser = res.data['userInfo'].filter(e => e.userEmail == mail);
      this.userInfo['fieldMap'] = selectedUser[0]['fieldMap'];
      this.storage.setData({ userInfo: this.userInfo });
      let user = this.userInfo;
      if (user && user['fieldMap']) {
        this.userRestrictionData = user['fieldMap'];
        let subModulesOfReports = Object.keys(this.userRestrictionData['Reports'].menu1);
        for (let i = 0; i < subModulesOfReports.length; i++) {
          if (this.userRestrictionData && (this.userRestrictionData['Reports'].checked || this.userRestrictionData['Reports'].indeterminate) && this.userRestrictionData['Reports'].menu1 && this.userRestrictionData['Reports'].menu1[subModulesOfReports[i]] && (this.userRestrictionData['Reports'].menu1[subModulesOfReports[i]].checked || this.userRestrictionData['Reports'].menu1[subModulesOfReports[i]].indeterminate)) {
            for (let j = 0; j < this.availableReports.length; j++) {
              if (subModulesOfReports[i] == this.availableReports[j].name) {
                this.reportModule.push(this.availableReports[j]);
              }
            }
          }

        }
      }
      setTimeout(() => {
        this.getReportName();
      }, 100)
      setTimeout(() => {
        this.showNoSearch = true;
      }, 200)
    }).catch((err) => {
      console.log(err);
    });
    // setTimeout(()=>{
    //   this.getReportName();
    // },100)
  }
  selectReportData(data) {
    // console.log(this.reportName.includes(data.name), data.path,`/organization/transport-manager/reports/${data.path}`)

    if (this.reportName.includes(data.name)) {
      this.router.navigate([`/organization/transport-manager/reports/${data.path}`]);
    }

  }
  getReportName() {
    this.reportModule.forEach(element => {
      this.reportName.push(element.name);
    });
  }


  findFilter() {
    for (let i = 0; i < this.reportModule.length; i++) {
      console.log(this.reportModule[i].name);

    }
    console.log(this.searchedValue);
  }

}
